import { CampaignBlocks, } from "@kvix/shared";
import { Avatar, makeStyles } from "@material-ui/core";
import { Rating } from "@material-ui/lab";
import React from "react";
import { Text } from "../../Primitives";
const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "start",
    },
    header: {
        display: "flex",
        width: "100%",
        marginBottom: 2,
    },
    titleRatingContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
    },
    avatar: {
        margin: "0 4px 4px 0",
    },
    title: {
        fontWeight: 700,
        marginLeft: 5,
    },
    text: {
        width: "100%",
    },
}));
export class CommentBlock {
    constructor() {
        this.defaultStructure = {
            name: CampaignBlocks.CommentBlock,
            titles: [""],
            subTitles: ["", ""],
            texts: [""],
            media: { images: [""] },
        };
        this.Render = (props) => {
            const classes = useStyles();
            const { media, titles, subTitles, texts } = props.block;
            return (React.createElement("div", { className: classes.root },
                React.createElement("div", { className: classes.header },
                    React.createElement(Avatar, { className: classes.avatar, src: media === null || media === void 0 ? void 0 : media.images[0] }),
                    React.createElement("div", { className: classes.titleRatingContainer },
                        React.createElement(Rating, { value: subTitles ? +subTitles[0] : 0, readOnly: true }),
                        React.createElement(Text, { variant: "body2", className: classes.title }, titles && titles[0]))),
                React.createElement(Text, { variant: "body2", className: classes.text }, texts && texts[0])));
        };
        this.Compose = (props) => {
            return React.createElement(React.Fragment, null);
        };
    }
}
//# sourceMappingURL=CommentBlock.js.map